import type { CreateCustomEventDto } from "@intelligems/ig-types";

export const generateCustomEventIdentifier = (
  event: Pick<CreateCustomEventDto, "name">
) => {
  const camelCaseName = event.name
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .split(" ")
    .filter(Boolean)
    .map((word, index) =>
      index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join("");

  // Generate a random 5-character string (A-Z only)
  const randomSuffix = Array.from({ length: 5 }, () =>
    String.fromCharCode(65 + Math.floor(Math.random() * 26))
  ).join("");

  let truncatedName = camelCaseName;
  if (camelCaseName.length > 25) {
    truncatedName = camelCaseName.slice(0, 25);
  }

  return `${truncatedName}${randomSuffix}`;
};
